import { Tabs } from 'antd';
import { t } from 'i18next';

import { Email } from 'widgets/Email/Email';
import { SMSService } from 'widgets/SMSService/SMSService';
import { WorkTime } from 'widgets/workTime/WorkTime';


const Config = () => {
  const tabItems = [{
    label: t('pages.sms-service'),
    key: '0',
    children: <SMSService />,
    forceRender: true
  }, {
    label: t('pages.email-settings'),
    key: '1',
    children: <Email />,
    forceRender: true
  }, {
    label: t('pages.work-time'),
    key: '2',
    children: <WorkTime/>,
    forceRender: true
  }];


  return (
    <div>
      <Tabs
        defaultActiveKey="0"
        items={tabItems}
      />
    </div>
  );
};

export default Config;
